import i18next from 'i18next';
import type { MarketCode } from '../../../../@types/MarketCode';
import type { CreditApplicationRedirectUrlPayload } from '../../../../Data/Payments/useCreditApplicationRedirectUrl';
import type { Persisted } from '../../../../reducers/credit-application';
import { phonenumbers } from '../../../../utils';

export interface FormState {
  id: string;
  ssn: string;
  estimatedMileage: string;
  email: string;
  telephone: string;
  downPayment: number;
  duration: number;
  persisted?: boolean;
}

export interface DefaultStateOptions {
  id: string;
  downPayment: number;
  duration: number;
  persisted: Persisted;
}

export const defaultState = (options: DefaultStateOptions): FormState => ({
  id: options.id,
  ssn: options.persisted.ssn || '',
  estimatedMileage: options.persisted.estimatedMileage?.toString() || '',
  email: options.persisted.email || '',
  telephone: options.persisted.telephone || '',
  downPayment: options.downPayment,
  duration: options.duration,
  persisted: !!options.persisted.ssn,
});

const Options = [
  {
    low: 0,
    high: 1500,
  },
  {
    low: 1500,
    high: 3000,
  },
  {
    low: 3000,
    high: 4500,
  },
  {
    low: 4500,
    high: 6000,
  },
  {
    low: 6000,
    high: 7500,
  },
];
const ns = 'credit-application-vfs';

export const createOptions = (marketCode: MarketCode) => [
  {
    displayName: i18next.t('fields.estimatedMileage.options.default', { ns }),
    value: '',
    disabled: true,
  },
  ...Options.map((option) => ({
    displayName: i18next.t('fields.estimatedMileage.options.range', {
      ns,
      low: marketCode === 'SE' ? option.low : option.low / 10,
      high: marketCode === 'SE' ? option.high : option.high / 10,
    }),
    value: option.high,
  })),
];

const transformEstimatedMileage = (estimated: string) => `UpTo${estimated}`;

export const validateTelephonenumber = (s: string, marketCode: MarketCode) => {
  const telephone = phonenumbers.parse(s, marketCode);
  return telephone?.isValid() || false;
};

export const FormStateToPayload = (
  _data: FormState,
  marketCode: MarketCode,
): CreditApplicationRedirectUrlPayload => {
  const cpy = { ..._data };
  delete cpy.persisted;

  const telephone = phonenumbers.parse(cpy.telephone, marketCode);
  const data: CreditApplicationRedirectUrlPayload = {
    ...cpy,
    estimatedMileage: transformEstimatedMileage(cpy.estimatedMileage),
    telephone: telephone?.getURI()?.replace(/\s/g, '') || '',
  };

  return data;
};

export const FormStateToPersisted = (_data: FormState, marketCode: MarketCode) => {
  if (!_data.persisted) return undefined;
  const telephone = phonenumbers.parse(_data.telephone, marketCode);
  const data: FormState = {
    ..._data,
    telephone: telephone?.formatNational()?.replace(/\s/g, '') || '',
  };

  return data;
};
